"use client";

import { motion } from 'framer-motion';
import AnimatedSection from '../AnimatedSection';
import { useTranslation } from 'react-i18next';

const CoffeeCharacteristicsSection = () => {
  const { t } = useTranslation();
  const characteristics = [
    { name: t("characteristics.flavor"), description: t("characteristics.flavor_description") },
    { name: t("characteristics.aroma"), description: t("characteristics.aroma_description") },
    { name: t("characteristics.body"), description: t("characteristics.body_description") },
    { name: t("characteristics.acidity"), description: t("characteristics.acidity_description") },
    { name: t("characteristics.finish"), description: t("characteristics.finish_description") },
  ];

  return (
    <section className="relative">
      {/* Background Image */}
      <motion.div 
        className="absolute inset-0 z-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <div 
          className="absolute inset-0 bg-brand-green"
          style={{
            backgroundImage: "url('/images/coffee/bg-caracteristicas.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.7)"
          }}
        />
      </motion.div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 py-24">
        <AnimatedSection delay={0.2} className="max-w-2xl mx-auto">
          <motion.h2 
            className="text-4xl font-bold mb-16 text-white"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            {t("characteristics.title")}
          </motion.h2>
          
          <div className="mt-12">
            {characteristics.map((item, index) => (
              <motion.div 
                key={index} 
                className="border-b border-white/30 py-4 grid grid-cols-3"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 + index * 0.1 }}
              >
                <div className="col-span-1">
                  <p className="text-white text-lg font-medium">{item.name}</p>
                </div>
                <div className="col-span-2">
                  <p className="text-white text-lg">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default CoffeeCharacteristicsSection;
